module.exports = __webpack_public_path__ + "static/media/nodejs.4c6c0929.png";